import React, {useState, useEffect} from 'react';
import { getHtmlId, getHtmlName } from './utils/CustomFieldHelpers';
import * as FieldTypes from './fields/index';

/*
Wrapper component for custom fields in Fusion Forms.  Dynamically loads the appropriate field component based on the field type.

To add a new field:
- Create a new component in the fields/ directory, e.g. TextField.jsx
- Export it from fields/index.js
- Ensure the file name and exported const match the field ctype used on the backend. i.e. `TextField`
- Ensure the the component supports all the defailt props passed to it:
  - field: the field object
  - name: the HTML name attribute for the field
  - id: the HTML id attribute for the field
  - onChange: a function to call when the field value changes

@param field - the field object, which contains the type and other properties
 */
export default ({ field, form, useDependency, setFieldValue, ...props }) => {
  const dependentYes = useDependency(field);

  if(!dependentYes) {
    return <></>;
  }

  const FieldClass = FieldTypes[field.type];

  if (!FieldClass) {
    console.error(`Unknown field type: ${field.type}`);
    return <div className="alert alert-danger">Unknown field type: {field.type}</div>;
  }

  const onChange = (e) => {
    const value = e?.target ? e.target.value : e;

    setFieldValue(field.mapped_name, value);

    return true;
  };

  return <div className={'custom-field'}>
    <FieldClass field={field} form={form} {...props} {...{onChange}}/>
  </div>;
};
